/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, dealName: NonNullable<unknown> }} Coinvestments_Senddrafts_Description2Inputs */

const en_coinvestments_senddrafts_description2 = /** @type {(inputs: Coinvestments_Senddrafts_Description2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Review and send ${i?.count} pending drafts for ${i?.dealName}.`)
};

/**
* | output |
* | --- |
* | "Review and send {count} pending drafts for {dealName}." |
*
* @param {Coinvestments_Senddrafts_Description2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_senddrafts_description2 = /** @type {((inputs: Coinvestments_Senddrafts_Description2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Senddrafts_Description2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_senddrafts_description2(inputs)
});
export { coinvestments_senddrafts_description2 as "coInvestments_sendDrafts_description" }